export default "__VITE_ASSET__BPDCAXsd__"